module.exports = __webpack_public_path__ + "f2f2cff109c10539c930058599614604.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/montserrat-bold-webfont.woff
// module id = 951
// module chunks = 0